import { render, staticRenderFns } from "./reserveParamsManageList.vue?vue&type=template&id=48a2d4a5&scoped=true"
import script from "./reserveParamsManageList.vue?vue&type=script&lang=js"
export * from "./reserveParamsManageList.vue?vue&type=script&lang=js"
import style0 from "./reserveParamsManageList.vue?vue&type=style&index=0&id=48a2d4a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a2d4a5",
  null
  
)

export default component.exports